import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { ActionMeta } from 'react-select';

import { ISelectInputProps, ISelectOption, SelectInput } from './SelectInput';

type Value = ISelectInputProps['value'];
export type ISelectInputFieldProps = ISelectInputProps & FieldProps<Value, FieldRenderProps<Value>>;

export const SelectInputField = (props: ISelectInputFieldProps) => (
  <Field {...props}>
    {({ input, meta }) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const handleChange = (activeOption: any, actionMeta: ActionMeta<ISelectOption>) => {
        const value = !activeOption || activeOption?.length === 0 ? undefined : activeOption;
        input.onChange(value);
        if (props.onChange) {
          props.onChange(value, actionMeta);
        }
      };
      const error = typeof props.error === 'boolean' ? props.error && meta.error : meta.touched && meta.error;
      const errorOnSubmit = meta.error && (meta.dirty || meta.submitFailed) && meta.touched && meta.error;
      return (
        <SelectInput
          {...props}
          {...input}
          onChange={handleChange}
          invalid={Boolean(props.validateOnSubmit ? errorOnSubmit : error)}
          error={props.validateOnSubmit ? errorOnSubmit : error}
        />
      );
    }}
  </Field>
);
